export default __webpack_public_path__ + "static/25-cea4ff21e8f6d135bf405e85299a143f.jpg";